
import { useData } from 'vitepress'
import { computed } from 'vue'
export function useCommentConfig() {
  const { theme } = useData()
  const type = computed(() => {
    return theme.value?.commentConfig?.type
  })
  const options = computed(() => {
    return theme.value?.commentConfig?.options
  })
  return  {
    type,
    options
  }
}

